<template>
  <div>
    <v-radio-group
      :label="label"
      v-model="data.Records[0].value"
      outlined
      class="pa-3 ma-3 radio-group"
      background-color="white"
      row
    >
      <v-radio v-for="v of checkbox" :key="v" :label="v" :value="v"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    record: Object,
    init: String,
    label: String,
    checkbox: Array,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: "a", form_id: 0, form_type: 7, menu: false }],
      },
    };
  },
  async mounted() {
    this.data.Records[0].value = this.init;
  },
};
</script>

<style></style>
